export const FIELD_TYPE = {
  SELECT: 'select',
  BUTTON: 'button',
  INPUT: 'input',
  RADIO: 'radio',
  DATEPICKER: 'datepicker',
}
